export const iconFontAwesomeEmojiFaceGrin = (
	<i className="fa-solid fa-face-grin"></i>
);
